module.exports = __webpack_public_path__ + "static/media/g17487.b98132ce.png";